import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const cn = (...classes) => {
  const filteredClasses = classes.filter(Boolean);
  const classString = filteredClasses.join(" ");

  const mbClasses = classString.match(/\bmb-\S+/g);
  if (mbClasses && mbClasses.length > 1) {
    const lastMbClass = mbClasses[mbClasses.length - 1];
    const withoutMb = classString.replace(/\bmb-\S+/g, "").trim();
    return `${withoutMb} ${lastMbClass}`.trim();
  }

  return classString;
};

const CustomInput = React.forwardRef(
  (
    {
      label,
      type = "text",
      value,
      onChange,
      error,
      placeholder,
      required = false,
      icon,
      className = "",
      labelClassName = "",
      inputClassName = "",
      disabled = false,
      readOnly = false,
      autoComplete,
      name,
      id,
      onBlur,
      onFocus,
      ...props
    },
    ref
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };

    const getInputType = () => {
      if (type === "password") {
        return showPassword ? "text" : "password";
      }
      return type;
    };

    return (
      <div className={`w-full ${className}`}>
        {label && (
          <label
            className={cn(
              "block text-sm font-medium text-ui-text mb-2",
              labelClassName
            )}
            htmlFor={id || name}
          >
            {label} {required && <span className="text-state-danger">*</span>}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-ui-text-muted">
              {icon}
            </div>
          )}
          <input
            type={getInputType()}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            ref={ref}
            disabled={disabled}
            readOnly={readOnly}
            autoComplete={autoComplete}
            name={name}
            id={id || name}
            onBlur={onBlur}
            onFocus={onFocus}
            className={`
              w-full h-12 px-4 border rounded-lg bg-ui-surface text-ui-text 
              placeholder:text-ui-text-muted focus:outline-none focus:ring-2 focus:ring-brand 
              focus:border-transparent transition-all duration-200
              ${icon ? "pl-10" : "pl-4"}
              ${type === "password" ? "pr-10" : "pr-4"}
              ${error ? "border-state-danger" : "border-ui-border"}
              ${disabled ? "opacity-50 cursor-not-allowed bg-ui-surface-sunken" : ""}
              ${readOnly ? "bg-ui-surface-sunken cursor-default" : ""}
              ${inputClassName}
            `}
            {...props}
          />
          {type === "password" && (
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-ui-text-muted hover:text-ui-text transition-colors duration-200"
            >
              {showPassword ? (
                <AiOutlineEyeInvisible size={20} />
              ) : (
                <AiOutlineEye size={20} />
              )}
            </button>
          )}
        </div>
        {error && <p className="text-state-danger text-sm mt-1">{error}</p>}
      </div>
    );
  }
);

CustomInput.displayName = "CustomInput";

export default CustomInput;
